<template>
    <div class="map-nav" :class="{'no-head':noHead}">
        <div id="container"></div>
        <transition name="slide">
            <section class="pane">
                <div class="txt">
                    <h4>{{storeInfo.name}}</h4>
                    <p>{{storeInfo.address}}</p>
                    <p v-if="storeInfo.serviceTime && !storeInfo.displayCloseReason">{{ `营业时间：${storeInfo.serviceTime}`}}</p>
                </div>
                <!-- <div class="btn-nav" @click="shwoPath">
                    <span >去这里</span> 
                </div> -->
            </section>
        </transition>
    </div>
</template>

<script>
import { mapMutations, mapGetters} from 'vuex'
import ajax from '@/api/ajax'
import { getAMapApi, addIconMarker, planPath } from './amap'
import { Indicator,Toast } from 'mint-ui'
import LocIcon from '@/assets/images/ico/ico-loc.png'
    export default {
        name:'storeNav',
        data () {
            return {
                map: null,
            }
        },
        computed: {
            ...mapGetters('storeMap', ['locLngLat', 'storeInfo']),
            noHead () {
                return Boolean(this.$route.query.noHead === 'true')
            }
        },
        methods: {
            ...mapMutations({
				setTitle:'setTitle',
				setShowHeader:'setShowHeader'
			}),
            async shwoPath() {
                Indicator.open()
                try {
                    const tip = await planPath({
                        map: this.map,
                        srcPos: this.locLngLat,
                        desPos: this.storeInfo,
                    })
                }catch(e) {
                    console.log(e)
                    Toast('请稍后重试！')
                }
                Indicator.close()
            }
        },
        beforeCreate () {
            this.$store.commit('setTitle', this._ll('导航'))
        },
        created () {
            this.setShowHeader(!this.noHead)
        },
        async mounted () {
            await getAMapApi()
            const { lng, lat } = this.storeInfo
            const map = new AMap.Map('container', {
                resizeEnable: true,                 // 是否监控地图容器尺寸变化
                zoom:12,                            // 初始化地图层级
                center: [lng, lat],                // 初始化地图中心点
                mapStyle: "amap://styles/whitesmoke"
            });
            this.map = map
            map.on('complete', function() {
                // 传入经纬度，设置地图中心点为定位标签
                addIconMarker({ map, ...this.storeInfo, LocIcon, imgUrl:LocIcon})
                map.setZoomAndCenter(16, [lng, lat])
                // 隐藏高德logo，版权
                var el = document.querySelector('#container .amap-logo')
                if (el) {
                    el.style.visibility = 'hidden'
                    el = document.querySelector('#container .amap-copyright')
                    el.style.visibility = 'hidden'
                }
            }.bind(this))
        },
    }
</script>

<style lang="scss" scoped>
    .amap-icon {
        overflow: auto !important;
    }
    .map-nav {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        max-width: 7.5rem;
        transform: translateX(-50%);
        width: 100%;
        display: flex;
        flex-direction: column;
        padding-top: 1rem;
        &.no-head {
            padding-top: 0;
        }
        .pane {
            font-size: .28rem;
            margin: .5rem;
            background: #fff;
            .txt {
                flex:1;
                h4 {
                    font-weight: 600;
                    font-size: .35rem;
                    color: #333333;
                }
                p {
                    padding: .2rem 0;
                    color: #666;
                }
            }
            .btn-nav {
                line-height: 3;
                text-align: center;
                >>>span {
                    display: inline-block;
                    width: 100%;
                    background:#DC1E32;
                    border-radius: .48rem;
                    font-size: .34rem;
                    color: #FFFFFF;
                    letter-spacing: .01rem;
                }
            }
        }
    }
    #container {
        width: 100%;
        height: 100%;
    }
    .slide-enter-active, .slide-leave-active {
        transition: max-height .3s;
    }
    .slide-enter, .slide-leave {
        max-height: 0;
    }
</style>


// WEBPACK FOOTER //
// src/pages/store/navigation.vue